import { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { TooltipProps } from '@mui/material/Tooltip';
import Tooltip from '../Tooltip';
import { COLORS } from '../../theme';

type CustomTooltipProps = {
  title: NonNullable<ReactNode>;
  placement?: TooltipProps['placement'];
  customSX?: TooltipProps['sx'];
  color?: 'primary' | 'secondary';
  CustomIcon?: ReactNode;
};

const InfoButton = ({
  title,
  placement = 'bottom',
  customSX = null,
  color = 'primary',
  CustomIcon = null,
}: CustomTooltipProps) => {
  const iconColor = color === 'primary' ? COLORS.indigo[600] : COLORS.gray[1000];

  return (
    <Tooltip title={title} placement={placement} enterTouchDelay={0} tabIndex={-1}>
      <IconButton sx={{ maxHeight: '20px', padding: '0px 4px', ...customSX }} disableRipple>
        {CustomIcon ? CustomIcon : <InfoIcon sx={{ color: iconColor, height: '20px' }} />}
      </IconButton>
    </Tooltip>
  );
};

export default InfoButton;
